import type { Dispatch } from '@reduxjs/toolkit'
import type { Business, User } from '@pbt/pbt-ui-components'

import { triggerErrorDoggo } from '~/utils/errorDoggoUtils'

import { TransactionFailureReasonName } from './paymentErrorMapping'

/**
 * Triggers error doggo for transaction failure, unless the failure is DEVICE_TIMEOUT.
 * DEVICE_TIMEOUT is a transient connectivity issue that doesn't warrant error reporting.
 */
export const triggerErrorDoggoForTransactionFailureIfNeeded = ({
  failureReasonName,
  dispatch,
  backendErrorMessage,
  fallbackMessage,
  currentUser,
  currentBusiness,
}: {
  backendErrorMessage: string | null
  currentBusiness?: Business | null
  currentUser?: User | null
  dispatch: Dispatch<any>
  failureReasonName: string | null | undefined
  fallbackMessage: string
}): void => {
  if (failureReasonName === TransactionFailureReasonName.DEVICE_TIMEOUT) {
    return
  }
  const message = backendErrorMessage || fallbackMessage
  triggerErrorDoggo(dispatch, message, 500, currentUser, currentBusiness)
}
